import configment from '@adc/configment';
import { ProductLine, headers as headersConstants } from '@adc/constants';
const { ATTRIBUTION_HEADER } = headersConstants;
export default (fetchImplementation) => function forAuctionGraph({ query, variables, operationName }, opts) {
    const body = { query, variables, operationName };
    const passthroughOpts = opts || {};
    const { headers = {}, requestTimeout } = passthroughOpts;
    if (!headers[ATTRIBUTION_HEADER]) {
        headers[ATTRIBUTION_HEADER] = configment.get('APP_THEME', ProductLine.AuctionCom);
    }
    if (requestTimeout) {
        headers['Auction-Graph-Duration-Budget'] = requestTimeout;
    }
    return fetchImplementation
        .fromService('RESI_GRAPH_API_URL')
        .post('/graphql', Object.assign(Object.assign({}, (passthroughOpts || {})), { useProxy: false, credentials: 'include', requestTimeout,
        headers,
        body }));
};
//# sourceMappingURL=graph.js.map